(function () {
  'use strict';
  var config = window.JollyI18nConfig || {};
  var dictionary = window.JollyI18nDictionary || { keys: {}, text: {} };
  var locale = config.locale || document.documentElement.lang || 'en';
  var root = (config.root || '/').replace(/\/$/, '') + '/';
  function normalized(value) { return String(value).replace(/\s+/g, ' ').trim(); }
  function text(value) {
    var original = String(value);
    var key = normalized(original);
    // Indentation is not translatable copy; preserving it avoids anonymous flex/grid items.
    if (!key) return original;
    if (!Object.prototype.hasOwnProperty.call(dictionary.text, key)) return original;
    var translated = String(dictionary.text[key]).trim();
    // Punctuation/identity entries must not append spaces on every observer pass.
    if (normalized(translated) === key) return original;
    return original.match(/^\s*/)[0] + translated + original.match(/\s*$/)[0];
  }
  function t(key, values) {
    var output = Object.prototype.hasOwnProperty.call(dictionary.keys, key) ? dictionary.keys[key] : key;
    return output.replace(/{{\s*(\w+)\s*}}/g, function (match, name) {
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }
  function url(value) {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return value;
    if (root !== '/' && (value === root.slice(0, -1) || value.startsWith(root))) return value;
    if (!/^\/(?:cart(?:[/.?]|$)|pages(?:\/|$)|products(?:\/|$)|collections(?:\/|$)|blogs(?:\/|$)|account(?:[/?]|$)|search(?:[/?]|$)|$)/.test(value)) return value;
    return root.replace(/\/$/, '') + value;
  }
  window.JollyI18n = {
    t: t, text: text, url: url, locale: locale,
    money: function (amount, currency) { return new Intl.NumberFormat(locale, {style:'currency', currency:currency}).format(Number(amount)); },
    date: function (date, options) { return new Intl.DateTimeFormat(locale, options || {dateStyle:'medium'}).format(new Date(date)); }
  };
  var translatedNodes = new WeakMap();
  var translatedAttributes = new WeakMap();
  function localizeElement(element) {
    if (!element || element.nodeType !== 1 || element.closest('script,style,svg,[translate="no"],[data-ja-no-translate]')) return;
    ['placeholder', 'aria-label', 'title', 'alt'].forEach(function (name) {
      if (element.hasAttribute(name)) {
        var original = element.getAttribute(name);
        var previous = translatedAttributes.get(element) || {};
        if (previous[name] === original) return;
        var translated = text(original);
        if (translated !== original) {
          previous[name] = translated;
          translatedAttributes.set(element, previous);
          element.setAttribute(name, translated);
        }
      }
    });
    if (element.tagName === 'A') {
      var original = element.getAttribute('href');
      var localized = url(original);
      if (localized !== original) element.setAttribute('href', localized);
    }
  }
  function localizeNode(node) {
    if (node.nodeType === 3) {
      if (!node.parentElement || node.parentElement.closest('script,style,svg,textarea,[contenteditable],[translate="no"],[data-ja-no-translate]')) return;
      if (translatedNodes.get(node) === node.nodeValue) return;
      var translated = text(node.nodeValue);
      if (translated !== node.nodeValue) {
        translatedNodes.set(node, translated);
        node.nodeValue = translated;
      }
      return;
    }
    if (node.nodeType !== 1 || node.closest('script,style,svg,[translate="no"],[data-ja-no-translate]')) return;
    localizeElement(node);
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (walker.currentNode.nodeType === 3) localizeNode(walker.currentNode);
      else localizeElement(walker.currentNode);
    }
  }
  function setupForms() {
    document.querySelectorAll('.lang-picker,.mob-lang').forEach(function (form) {
      var input = form.querySelector('input[name="return_to"]');
      if (!input) { input = document.createElement('input'); input.type='hidden'; input.name='return_to'; form.appendChild(input); }
      input.value = window.location.pathname + window.location.search;
    });
  }
  function init() {
    setupForms();
    if (locale.split('-')[0] === 'en') return;
    localizeNode(document.body);
    var observer = new MutationObserver(function (mutations) {
      var pending = new Set();
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') mutation.addedNodes.forEach(function (node) { pending.add(node); });
        else if (mutation.type === 'attributes') localizeElement(mutation.target);
        else pending.add(mutation.target);
      });
      pending.forEach(localizeNode);
    });
    observer.observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['placeholder','aria-label','title','alt','href']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
